import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../images/about/bannerabout.png";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Who We Are">
                <h1>About TekRevol</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol is an enterprise software development company helping
                  startups and organizations build and implement digital
                  transformation solutions tailored to their demand and needs.
                </p>
                <ul>
                  <li>Tech Integrated Solutions</li>
                  <li>Client Focused Approach</li>
                  <li>Disruptive Innovation</li>
                  <li>Digital Transformation Partner</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto ms-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
